export const situationSerializationErrorTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (categoryid !== undefined && desyncdata !== undefined) {
		if (categoryid.indexOf('situation_serialization.py') !== -1 && desyncdata.indexOf('Exception occurred while attempting to populate a repeated field') !== -1) {
			return {
				type: 'situationSerializationError',
				color: 'IndianRed',
				title: 'Situation Serialization Error',
				text: 'Situation or Goal data is missing.',
				description: 'Most likely an outdated modification is failing to provide necessary data to save a running situation instance.<br/><br/>' +
        'You need to locate the PACKAGE file, in your The Sims 4 Mods folder, that could be causing this issue and remove it. Try starting with the oldest modifications you have.<br/>' +
        'If this is a new issue, try removing the most recent mod you have installed.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
  <report>
    <version>2</version>
    <sessionid>59ec92986bb3c645b63b2a7</sessionid>
    <type>desync</type>
    <sku>ea.maxis.sims4_64.15.pc</sku>
    <createtime>2099-08-02 21:36:13</createtime>
    <buildsignature>Local.Unknown.Unknown.1.99.62.1020-1.200.000.360.Release</buildsignature>
    <categoryid>situation_serialization.py:865</categoryid>
    <desyncid>59ec92986bb3c645b63b2a7</desyncid>
    <systemconfig/>
    <screenshot/>
    <desyncdata>Exception occurred while attempting to populate a repeated field: (AttributeError: 'NoneType' object has no attribute 'guid64')
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 179, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 202, in c_api_server_tick
  File &quot;T:\InGame\Gameplay\Scripts\Server\scheduling.py&quot;, line 212, in simulate
  File &quot;T:\InGame\Gameplay\Scripts\Server\elements.py&quot;, line 376, in _run
  File &quot;T:\InGame\Gameplay\Scripts\Server\services\persistence_service.py&quot;, line 391, in call_save_game_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 405, in request_client_disconnect_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\services\persistence_service.py&quot;, line 407, in save_to_scratch_slot_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\services\persistence_service.py&quot;, line 425, in save_game_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\services\persistence_service.py&quot;, line 468, in _save_game_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\services\persistence_service.py&quot;, line 527, in _fill_and_send_save_game_protobufs_gen
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\service_manager.py&quot;, line 512, in save_all_services
  File &quot;T:\InGame\Gameplay\Scripts\Server\zone_manager.py&quot;, line 118, in save
  File &quot;T:\InGame\Gameplay\Scripts\Server\zone.py&quot;, line 1495, in save_zone
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\service_manager.py&quot;, line 512, in save_all_services
  File &quot;T:\InGame\Gameplay\Scripts\Server\situations\situation_manager.py&quot;, line 1038, in save
  File &quot;T:\InGame\Gameplay\Scripts\Server\situations\situation_serialization.py&quot;, line 779, in serialize_seeds_to_zone
  File &quot;T:\InGame\Gameplay\Scripts\Server\situations\situation_serialization.py&quot;, line 867, in serialize_to_proto
  File &quot;T:\InGame\Gameplay\Scripts\Server\distributor\rollback.py&quot;, line 32, in __exit__
  File &quot;T:\InGame\Gameplay\Scripts\Server\situations\situation_serialization.py&quot;, line 865, in serialize_to_proto
AttributeError: 'NoneType' object has no attribute 'guid64'
</desyncdata>
  </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/situationSerializationErrorTest.js